import { useCallback, useMemo } from "react";

import { orderTableColumnsConfig } from "./orderTableColumnsConfig";

import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { selectOrderState } from "../../../store/order/orderFilterSlice";
import {
  selectOrders,
  useGetOrdersListQuery,
} from "../../../services/order/orderApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";
import { useSelector } from "react-redux";

export const OrderTablePage = () => {
  const appliedFilters = useSelector(selectOrderState);
  const { isLoading, isFetching } = useGetOrdersListQuery(appliedFilters);
  const tableData = useSelector(selectOrders);

  const navigate = useNavigate();

  const handleOpenModal = useCallback((rowData, action) => {
    // Implement your modal logic here
    console.log("Row Data: ", rowData, "Action: ", action);
  }, []);

  const handleOrderDetails = useCallback(
    (orderId) => navigate(`/orders/${orderId}`),
    [navigate],
  );

  const columnDefs = useMemo(
    () => orderTableColumnsConfig(handleOpenModal, handleOrderDetails),
    [handleOpenModal, handleOrderDetails],
  );
  if (isLoading && tableData.length === 0) {
    return <CategoryPageSkeleton />;
  }

  return (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading}
      isFetching={isFetching}
    />
  );
};
